import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetAllBlogPost } from '../services/apiservice';
import BlogItemGrid from '../Components/BlogItemGrid';
import Loader from '../Components/Loader';

const BlogList = () => {
  const [blogPost, setBlogPost] = useState([]);
  const [loading, setLoading] = useState(true);

  const fillBlogPost = async () => {
    try {
      const postList = await GetAllBlogPost();
      const jsonPostList = JSON.parse(postList);
      setBlogPost(jsonPostList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillBlogPost();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Blog - Latest Insights on Data & Development - Data Beautifier</title>
        <meta name="description" content="Explore our blog for the latest tips, tutorials, and insights on data transformation, web development, and coding tools." />
        <link rel="canonical" href="https://databeautifier.com/blog" />
      </Helmet>
      <Header />
      <div class="blog-area ptb-20">
            <div class="container-block-fluid">
                <div class="row justify-content-center">
                  {
                  loading ? <Loader /> :
                    blogPost?.length == 0 ? "No Blog Post Published yet." :
                      blogPost?.map((item) => (
                        <BlogItemGrid blogitem={item} />
                      ))
                } 
                </div>
            </div>
        </div>
      <Footer />
    </div>
  );
};

export default BlogList;